
import React from 'react';
import { mdx } from '@mdx-js/react';


export const frontMatter = {
	id: 'start',
	title: 'Getting Started'
};
export const contentTitle = undefined;
export const metadata = {
  "unversionedId": "start",
  "id": "start",
  "isDocsHomePage": false,
  "title": "Getting Started",
  "description": "Before you begin, you need to create an account with Internet of Insurance. To register for the IOI platform, please contact IOI support at support@InternetOfInsurance.org.",
  "source": "@site/docs/getting-started.md",
  "sourceDirName": ".",
  "slug": "/start",
  "permalink": "/docs/start",
  "tags": [],
  "version": "current",
  "frontMatter": {
    "id": "start",
    "title": "Getting Started"
  },
  "sidebar": "docs",
  "next": {
    "title": "Data Access and Integration Paths",
    "permalink": "/docs/integration-options"
  }
};


/* @jsxRuntime classic */
/* @jsx mdx */

export const toc = [];

const layoutProps = {
  toc
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Before you begin, you need to create an account with Internet of Insurance. To register for the IOI platform, please contact IOI support at `}<a parentName="p" {...{
        "href": "mailto:support@InternetOfInsurance.org"
      }}>{`support@InternetOfInsurance.org`}</a>{`.`}</p>
    <p><a parentName="p" {...{
        "href": "api-reference/authentication"
      }}>{`Click here`}</a>{` to learn about authentication. `}</p>
    <p>{`You have the option to use our UAT environment to test your integration, the API base URLs are:`}</p>
    <ul>
      <li parentName="ul">{`PROD: `}<inlineCode parentName="li">{`https://api.dais.com/ioi/v3/`}</inlineCode></li>
      <li parentName="ul">{`UAT: `}<inlineCode parentName="li">{`https://api.uat.dais.com/ioi/v3/`}</inlineCode></li>
    </ul>
    <p>{`Now you can dive right in or look at one of our Getting Started Guides below.`}</p>
    <div {...{
      "className": "admonition admonition-info alert alert--info"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
              }}></path></svg></span>{`info`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`To learn how to connect to get a quote, `}<a parentName="p" {...{
            "href": "getting-started/getting-a-quote"
          }}>{`click here`}</a>{` for the guide.`}</p></div></div>
    <div {...{
      "className": "admonition admonition-info alert alert--info"
    }}><div parentName="div" {...{
        "className": "admonition-heading"
      }}><h5 parentName="div"><span parentName="h5" {...{
            "className": "admonition-icon"
          }}><svg parentName="span" {...{
              "xmlns": "http://www.w3.org/2000/svg",
              "width": "14",
              "height": "16",
              "viewBox": "0 0 14 16"
            }}><path parentName="svg" {...{
                "fillRule": "evenodd",
                "d": "M7 2.3c3.14 0 5.7 2.56 5.7 5.7s-2.56 5.7-5.7 5.7A5.71 5.71 0 0 1 1.3 8c0-3.14 2.56-5.7 5.7-5.7zM7 1C3.14 1 0 4.14 0 8s3.14 7 7 7 7-3.14 7-7-3.14-7-7-7zm1 3H6v5h2V4zm0 6H6v2h2v-2z"
              }}></path></svg></span>{`info`}</h5></div><div parentName="div" {...{
        "className": "admonition-content"
      }}><p parentName="div">{`To learn how to create a policy record in a policy system, `}<a parentName="p" {...{
            "href": "getting-started/connecting-to-a-policy-service"
          }}>{`click here`}</a>{` for the guide`}</p></div></div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
